enum ClueyIntegrationDataStatus {
  received = 'received',
  released = 'released',
  rejected = 'rejected',
}

export default ClueyIntegrationDataStatus
